import React from 'react';
import { Box, Typography, Slide } from '@mui/material';
import { WifiOff as WifiOffIcon } from '@mui/icons-material';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();

  return (
    <Slide direction="down" in={!isOnline} mountOnEnter unmountOnExit>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          py: 0.75,
          px: 2,
          background: 'linear-gradient(90deg, rgba(255,215,64,0.15), rgba(255,215,64,0.1))',
          borderBottom: '1px solid rgba(255,215,64,0.3)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <WifiOffIcon sx={{ fontSize: 16, color: '#FFD740' }} />
        <Typography
          sx={{
            fontFamily: 'var(--font-mono)',
            fontSize: '0.7rem',
            fontWeight: 600,
            color: '#FFD740',
            letterSpacing: 0.5,
          }}
        >
          Offline — showing cached data
        </Typography>
      </Box>
    </Slide>
  );
};

export default OfflineBanner;
